<script setup lang="ts">
import type { SlugHeaderContentProps } from '.';

defineProps<SlugHeaderContentProps>();
</script>

<template>
  <div class="pt-r6 gap-r8 flex flex-col text-black lg:hidden">
    <PageContainerAlignment class="gap-r8 flex flex-col">
      <div class="flex flex-col">
        <AppHeading tag="h2" size="md" class="text-client-orange">
          {{ subtitle }}
        </AppHeading>
        <AppHeading tag="h1" size="custom" class="text-4xl">
          {{ title }}
        </AppHeading>
      </div>

      <div class="gap-r4 flex flex-wrap items-center">
        <AppLink
          v-for="(link, i) in links"
          :key="i"
          type="custom"
          :to="link.to"
          :opts="{ link: { external: true, target: '_blank' } }"
          class="text-client-orange gap-r2 inline-flex items-center uppercase underline underline-offset-2"
        >
          <AppIcon v-if="link.icon" :name="link.icon" size="md" />
          <AppText size="lg">{{ link.label }}</AppText>
        </AppLink>
      </div>
    </PageContainerAlignment>

    <div class="relative">
      <div class="relative aspect-3/4 min-h-screen max-w-full">
        <div
          style="
            background: linear-gradient(
              232.13deg,
              #000000 0%,
              rgba(0, 0, 0, 0) 47.66%
            );
          "
          class="absolute top-0 right-0 aspect-square w-3/4 xl:w-1/2"
        >
          <AppIcon
            :name="icon"
            size="custom"
            class="top-r5 right-r5 absolute size-24 drop-shadow-xl drop-shadow-black"
          />
        </div>
        <img
          :src="imageHeader.url"
          :alt="imageHeader.alt"
          class="size-full object-cover"
        />
      </div>

      <div
        class="from-client-black/0 to-client-black absolute inset-0 size-full bg-linear-to-b"
      ></div>
      <PageContainerAlignment class="absolute bottom-0">
        <AppParagraph class="text-client-white">
          {{ description }}
        </AppParagraph>
      </PageContainerAlignment>
    </div>
  </div>
</template>
